import dayjs from "dayjs";

export const formatDateAndTime = (value: string) => {
  if (!value) return "";

  const date = dayjs(value);

  // Detect locale
  const locale = navigator.language || navigator.languages?.[0] || "en-US";
  const isUSLocale = locale.startsWith("en-US") || locale.startsWith("en");

  if (isUSLocale) {
    // US format: "Jan 17, 2025 · 3:45 PM"
    const month = date.format("MMM");
    const day = date.format("D");
    const year = date.format("YYYY");
    const time = date.format("h:mm A");
    return `${month} ${day}, ${year} · ${time}`;
  }
  // Europe format: "17 Jan 2025 · 15:45"
  const day = date.format("D");
  const month = date.format("MMM");
  const year = date.format("YYYY");
  const time = date.format("HH:mm");
  return `${day} ${month} ${year} · ${time}`;
};

export const formatDate = (value: string) => {
  return dayjs(value).format("YYYY-MM-DD");
};
